import * as React from 'react';
import { MoreDetailedContainer } from '../../../containers/OfferHistory/MoreDetailedContainer';

import * as styles from './styles.css';
import { IOffersHistoryProps } from './types';

export const OffersHistory: React.FC<IOffersHistoryProps> = props => {
  return (
    <>
      <div data-name="OffersHistory" className={styles['filters']}>
        {props.filters}
      </div>

      <MoreDetailedContainer />

      <div className={styles['feed']}>{props.feed}</div>

      {props.showMoreBtn}
    </>
  );
};

OffersHistory.displayName = 'OffersHistory';
